import { render, staticRenderFns } from "./MessageMarkdown.vue?vue&type=template&id=09ff44de&"
import script from "./MessageMarkdown.vue?vue&type=script&lang=js&"
export * from "./MessageMarkdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports